import { useState } from 'react';

import ChipFilter from '../../shared/ChipFilter';
import { ButtonRow, MutedText, Row } from '../../../styles';
import { ModalShell } from '../styles';

const TABS = [
  'All Favorites',
  'Highly rated',
  'Past workers',
  'Others',
] as const;
type Tab = (typeof TABS)[number];

type SendInvitationsModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onContinue: (config: {
    sameWorkerForAllDates: boolean;
    openJobIfUnfilled: boolean;
    selectedTab: Tab;
  }) => void;
};

const SendInvitationsModal = ({
  isOpen,
  onCancel,
  onContinue,
}: SendInvitationsModalProps) => {
  const [sameWorker, setSameWorker] = useState(false);
  const [openIfUnfilled, setOpenIfUnfilled] = useState(true);
  const [tab, setTab] = useState<Tab>(TABS[0]);

  if (!isOpen) return null;

  return (
    <ModalShell role="dialog" aria-label="Invite workers">
      <h4>Invite workers</h4>
      <label>
        <input
          type="checkbox"
          checked={sameWorker}
          onChange={(event) => setSameWorker(event.target.checked)}
        />{' '}
        Same worker for all dates
      </label>
      <label>
        <input
          type="checkbox"
          checked={openIfUnfilled}
          onChange={(event) => setOpenIfUnfilled(event.target.checked)}
        />{' '}
        Open job to more workers if needed
      </label>
      <MutedText>
        We&apos;ll open the job to more qualified workers if shifts aren&apos;t
        filled.
      </MutedText>
      <Row gap="sm" wrap css={{ marginTop: 8 }}>
        {TABS.map((label) => (
          <ChipFilter
            key={label}
            label={label}
            active={tab === label}
            onClick={() => setTab(label)}
          />
        ))}
      </Row>
      <ButtonRow>
        <button type="button" onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          onClick={() =>
            onContinue({
              sameWorkerForAllDates: sameWorker,
              openJobIfUnfilled: openIfUnfilled,
              selectedTab: tab,
            })
          }
        >
          Continue
        </button>
      </ButtonRow>
    </ModalShell>
  );
};

export default SendInvitationsModal;
